import { gql } from '@apollo/client';
import { OtpFields } from './fragments';

export const SEND_SMS_OTP = gql`
  mutation SendSmsOtp($input: SendOtpInput!) {
    sendOtp(input: $input)
  }
`;

export const VERIFY_SMS_OTP = gql`
  mutation VerifySmsOtp($input: VerifyOtpInput!) {
    verifyOtp(input: $input) {
      ...OtpFields
    }
  }
  ${OtpFields}
`;

export const SEND_EMAIL_OTP = gql`
  mutation SendEmailOtp($input: SendEmailVerificationInput!) {
    sendEmailOtp(input: $input)
  }
`;

export const VERIFY_EMAIL_OTP = gql`
  mutation VerifyEmailOtp($input: VerifyEmailInput!) {
    verifyEmailOtp(input: $input) {
      ...OtpFields
    }
  }
  ${OtpFields}
`;
